import { render, staticRenderFns } from "./AverageDeliveryTimeByArea.vue?vue&type=template&id=a4dea97e&lang=pug&"
import script from "./AverageDeliveryTimeByArea.vue?vue&type=script&lang=ts&"
export * from "./AverageDeliveryTimeByArea.vue?vue&type=script&lang=ts&"
import style0 from "./AverageDeliveryTimeByArea.vue?vue&type=style&index=0&id=a4dea97e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports